import { filter, get } from 'lodash-es'
export const formatBrandKnowledge = (knowledge) => {
  switch (knowledge) {
    case 'primary':
      return 'Förstahandsval'
    case 'recommending':
      return 'Rek. regelbundet'
    case 'testing':
      return 'Testar/Rek. ibland'
    case 'understands':
      return 'Förstår'
    case 'knowledge':
      return 'Kännedom'
    case 'none':
      return 'Ingen kännedom'
    default:
      return knowledge
  }
}

export const formatProductPlacement = (placement) => {
  switch (placement) {
    case 'shelf':
      return 'I hyllan'
    case 'behindRegister':
      return 'Bakom kassan'
    case 'onDemand':
      return 'Beställningsvara'
    case 'other':
      return 'Annat'
    default:
      return placement
  }
}

export const formatCompetitionChoice = (choice) => {
  switch (choice) {
    case 'habit':
      return 'Vana'
    case 'betterProduct':
      return 'Speciell/Bättre egenskap'
    case 'betterPrice':
      return 'Bättre pris'
    case 'notRecommendingCompetitor':
      return 'Rekommenderar ej'
    case 'other':
      return 'Annat'
    default:
      return choice
  }
}
export const formatShelfAppearance = (appearance) => {
  switch (appearance) {
    case 'asExpected':
      return 'Som förväntat'
    case 'didNotExist':
      return 'Fanns ej i hyllan'
    case 'notRefilled':
      return 'Ej påfyllt'
    case 'messy':
      return 'Ostädat'
    case 'campaignMissing':
      return 'Kampanj fattades'
    default:
      return appearance
  }
}

export const formatPharmacy = (pharmacy) => {
  switch (pharmacy) {
    case 'apoteketHjartat':
      return 'Apotek Hjärtat'
    case 'apotekGruppen':
      return 'Apoteksgruppen'
    case 'lloyds':
      return 'Lloyds Apotek'
    case 'kronans':
      return 'Kronans Apotek'
    case 'apoteket':
      return 'Apoteket AB'
    default:
      return pharmacy
  }
}

export const formatCity = (city) => {
  switch (city) {
    case 'stockholm':
      return 'Stockholm/Svealand'
    case 'goteborg':
      return 'Göteborg/Götaland'
    case 'skane':
      return 'Skåne/Södra Götaland'
    case 'uppsala': //Note: This us key word uppsala but its for Norrland (yes confusing) But it currently correct.
      return 'Norrland'
    default:
      return city
    // code block
  }
}

export const formatMeetingNr = (meetingNr) => {
  switch (meetingNr) {
    case '1':
      return 'Möte 1'
    case '2':
      return 'Möte 2'
    case '3':
      return 'Möte 3'
    default:
      return meetingNr
    // code block
  }
}

export const generateDataPoint = (
  data,
  attribute,
  key,
  formatFunction = null
) => {
  const numberOfPoints = filter(data, (item) => {
    const value = get(item, attribute, '')
    return value ? value.includes(key) : false
  }).length
  return {
    value: numberOfPoints,
    name: formatFunction ? formatFunction(key) : key,
  }
}
